import { Clip, Nice } from '@/components/icon'
import { Comment } from '@/types/comment'

interface Props {
  comment: Comment
  onClick: (type: string, commentId: number) => void
}

export const ActionButtons: React.FC<Props> = ({ comment, onClick }) => {
  const isNiced = comment.is_niced
  const isCliped = comment.is_clipped
  const normalStyle = 'text-fl-dark'
  const doneStyle = 'text-fl-blue font-bold'
  return (
    <div className="flex justify-end text-xs sm:text-sm">
      <div
        className="flex items-center pr-4 cursor-pointer"
        onClick={() => onClick('nice', comment.id)}
      >
        <Nice color={isNiced ? '#1A6DCC' : '#666666'} />
        <span className={`px-1 ${isNiced ? doneStyle : normalStyle}`}>
          なるほど
        </span>
        <span className={`px-[30px] ${isNiced ? doneStyle : normalStyle}`}>
          {comment.nice_count}
        </span>
      </div>
      <div
        className="flex items-center cursor-pointer"
        onClick={() => onClick('clip', comment.id)}
      >
        <Clip color={isCliped ? '#1A6DCC' : '#666666'} />
        <span className={`px-1 ${isCliped ? doneStyle : normalStyle}`}>
          クリップ
        </span>
        <span className={`pl-[30px] ${isCliped ? doneStyle : normalStyle}`}>
          {comment.clip_count}
        </span>
      </div>
    </div>
  )
}
